import { subscriptionTypes } from 'rp-auth';

const isProd = location =>
  location.origin === 'https://www.racingpost.com' ||
    location.origin === 'https://janus.racingpost.com';

export const SERVICE_ID_ESSENTIAL_ULTIMATE_MONTHLY = isProd(global.location) ? 12560 : 12576;
export const SERVICE_ID_ESSENTIAL_ULTIMATE_ANNUAL = isProd(global.location) ? 12561 : 12577;
export const SERVICE_ID_ULTIMATE_MONTHLY = isProd(global.location) ? 12562 : 12570;
export const SERVICE_ID_ULTIMATE_ANNUAL = isProd(global.location) ? 12563 : 12575;
export const SERVICE_ID_ESSENTIAL_ANNUAL_VIP = isProd(global.location) ? 12564 : 12612;
export const SERVICE_ID_ULTIMATE_ANNUAL_VIP = isProd(global.location) ? 12565 : 12611;

export const SERVICE_ID_TIPPING_MONTHLY = isProd(global.location) ? 19855 : 24768;
export const SERVICE_ID_TIPPING_ANNUAL = isProd(global.location) ? 19854 : 24769;
export const SERVICE_ID_INSIGHTS_MONTHLY = isProd(global.location) ? 19856 : 24862;
export const SERVICE_ID_INSIGHTS_ANNUAL = isProd(global.location) ? 19857 : 24863;

export const SERVICE_REFERENCE_ESSENTIAL_ULTIMATE_MONTHLY = isProd(global.location)
  ? '0010MG527DGB8BX6E0'
  : '0010MVZF2VFOLS1SP2';
export const SERVICE_REFERENCE_ESSENTIAL_ULTIMATE_ANNUAL = isProd(global.location)
  ? '0010MPJFLFS5TMV053'
  : '0010ML2SJ27PHMZJP0';
export const SERVICE_REFERENCE_ULTIMATE_MONTHLY = isProd(global.location)
  ? '0010CDXZX5BL055PQ0'
  : '0010CAA1E7FCJDIA21';
export const SERVICE_REFERENCE_ULTIMATE_ANNUAL = isProd(global.location)
  ? '0010CPTHDVUZD18MZ0'
  : '0010CHGPW0D90ITSP0';
export const SERVICE_REFERENCE_ESSENTIAL_ANNUAL_VIP = isProd(global.location)
  ? '0010CTFSF290LJ8372'
  : '0010CS66JRVAA2KSG0';
export const SERVICE_REFERENCE_ULTIMATE_ANNUAL_VIP = isProd(global.location)
  ? '0010C7ADGJIYKIAER2'
  : '0010CQR788HUNX4961';

export const SERVICE_REFERENCE_TIPPING_MONTHLY = isProd(global.location)
  ? '0010CA13IX3CHGNG63'
  : '0010CT5NLW55GK0G93';
export const SERVICE_REFERENCE_TIPPING_ANNUAL = isProd(global.location)
  ? '0010C67PHMD23SFN80'
  : '0010CRK3RPHG3M5371';
export const SERVICE_REFERENCE_INSIGHTS_MONTHLY = isProd(global.location)
  ? '0010C3OVE4RLDR7C10'
  : '0010CSEK9TCP7YDVP1';
export const SERVICE_REFERENCE_INSIGHTS_ANNUAL = isProd(global.location)
  ? '0010CDAETUGYSM3GH2'
  : '0010CGWHB5AEK5V9F3';

const { ESSENTIAL, TIPPING, ULTIMATE } = subscriptionTypes;

const SERVICE_TIPPING_TYPE = TIPPING.toUpperCase();
// const SERVICE_INSIGHTS_TYPE = 'INSIGHTS.toUpperCase()';
const SERVICE_ESSENTIAL_TYPE = ESSENTIAL.toUpperCase();
const SERVICE_ULTIMATE_TYPE = ULTIMATE.toUpperCase();

const SERVICE_ESSENTIAL_BADGE = 'https://www.rp-assets.com/pdfs/BADGE_essential_163x200.png';
const SERVICE_ULTIMATE_BADGE = 'https://www.rp-assets.com/pdfs/BADGE_ultimate_145x200.png';
const SERVICE_TIPPING_BADGE = 'https://www.rp-assets.com/pdfs/BADGE_essential_163x200.png';
const SERVICE_INSIGHTS_BADGE = 'https://www.rp-assets.com/pdfs/BADGE_ultimate_145x200.png';

const SERVICE_ESSENTIAL_IMAGE = 'https://www.rp-assets.com/pdfs/IMAGE_3%20devices_432x225.png';
const SERVICE_ULTIMATE_IMAGE = 'https://www.rp-assets.com/pdfs/devices_2_432x225.png';
const SERVICE_TIPPING_IMAGE = 'https://www.rp-assets.com/pdfs/IMAGE_3%20devices_432x225.png';
const SERVICE_INSIGHTS_IMAGE = 'https://www.rp-assets.com/pdfs/devices_2_432x225.png';

const SERVICE_TIPPING_ALT = 'tipping subscription';
const SERVICE_INSIGHTS_ALT = 'insights subscription';
const SERVICE_ESSENTIAL_ALT = 'essential subscription';
const SERVICE_ULTIMATE_ALT = 'ultimate subscription';

const SERVICES = [
  {
    id: SERVICE_ID_ESSENTIAL_ULTIMATE_MONTHLY,
    referenceId: SERVICE_REFERENCE_ESSENTIAL_ULTIMATE_MONTHLY,
    type: SERVICE_ESSENTIAL_TYPE,
    badge: SERVICE_ESSENTIAL_BADGE,
    image: SERVICE_ESSENTIAL_IMAGE,
    alt: SERVICE_ESSENTIAL_ALT,
    offer: true,
  },
  {
    id: SERVICE_ID_ESSENTIAL_ULTIMATE_ANNUAL,
    referenceId: SERVICE_REFERENCE_ESSENTIAL_ULTIMATE_ANNUAL,
    type: SERVICE_ESSENTIAL_TYPE,
    badge: SERVICE_ESSENTIAL_BADGE,
    image: SERVICE_ESSENTIAL_IMAGE,
    alt: SERVICE_ESSENTIAL_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_ULTIMATE_MONTHLY,
    referenceId: SERVICE_REFERENCE_ULTIMATE_MONTHLY,
    type: SERVICE_ULTIMATE_TYPE,
    badge: SERVICE_ULTIMATE_BADGE,
    image: SERVICE_ULTIMATE_IMAGE,
    alt: SERVICE_ULTIMATE_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_ULTIMATE_ANNUAL,
    referenceId: SERVICE_REFERENCE_ULTIMATE_ANNUAL,
    type: SERVICE_ULTIMATE_TYPE,
    badge: SERVICE_ULTIMATE_BADGE,
    image: SERVICE_ULTIMATE_IMAGE,
    alt: SERVICE_ULTIMATE_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_ESSENTIAL_ANNUAL_VIP,
    referenceId: SERVICE_REFERENCE_ESSENTIAL_ANNUAL_VIP,
    type: SERVICE_ESSENTIAL_TYPE,
    badge: SERVICE_ESSENTIAL_BADGE,
    image: SERVICE_ESSENTIAL_IMAGE,
    alt: SERVICE_ESSENTIAL_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_ULTIMATE_ANNUAL_VIP,
    referenceId: SERVICE_REFERENCE_ULTIMATE_ANNUAL_VIP,
    type: SERVICE_ULTIMATE_TYPE,
    badge: SERVICE_ULTIMATE_BADGE,
    image: SERVICE_ULTIMATE_IMAGE,
    alt: SERVICE_ULTIMATE_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_TIPPING_MONTHLY,
    referenceId: SERVICE_REFERENCE_TIPPING_MONTHLY,
    type: SERVICE_TIPPING_TYPE,
    badge: SERVICE_TIPPING_BADGE,
    image: SERVICE_TIPPING_IMAGE,
    alt: SERVICE_TIPPING_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_TIPPING_ANNUAL,
    referenceId: SERVICE_REFERENCE_TIPPING_ANNUAL,
    type: SERVICE_TIPPING_TYPE,
    badge: SERVICE_TIPPING_BADGE,
    image: SERVICE_TIPPING_IMAGE,
    alt: SERVICE_TIPPING_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_INSIGHTS_MONTHLY,
    referenceId: SERVICE_REFERENCE_INSIGHTS_MONTHLY,
    type: SERVICE_ESSENTIAL_TYPE,
    badge: SERVICE_INSIGHTS_BADGE,
    image: SERVICE_INSIGHTS_IMAGE,
    alt: SERVICE_INSIGHTS_ALT,
    offer: false,
  },
  {
    id: SERVICE_ID_INSIGHTS_ANNUAL,
    referenceId: SERVICE_REFERENCE_INSIGHTS_ANNUAL,
    type: SERVICE_ESSENTIAL_TYPE,
    badge: SERVICE_INSIGHTS_BADGE,
    image: SERVICE_INSIGHTS_IMAGE,
    alt: SERVICE_INSIGHTS_ALT,
    offer: false,
  },
];

function getServiceProperty(serviceId, propertyName) {
  return SERVICES.find(service => service.id === serviceId)[propertyName];
}

export function getServicePropertyBySubscriptionReference(subscriptionReference, propertyName) {
  return SERVICES.find(service => service.referenceId === subscriptionReference)[propertyName];
}

export function checkSubscriptionReference(subscriptionReference) {
  const service = Boolean(SERVICES.find(service => service.referenceId === subscriptionReference));
  return service;
}

export default getServiceProperty;
